export const getStoreInfos = (state) => state.storeInfos;
